export enum Side {
    Left,
    Top,
    Right,
    Bottom
}
